module.exports = __webpack_public_path__ + "img/4.2.f1bab5b8.png";